<template>
  <b-card no-body class="gridlay">
    <b-card-header class="m-0 p-0 h-fixed" align="center" v-if="object">
      <!-- <entity-media-wrapper :entity="object"></entity-media-wrapper> -->
      <job-media-wrapper :job="object"></job-media-wrapper>
    </b-card-header>

    <b-card-body class="pb-3 pt-3 pr-0 text-truncate footer-auto-bottom" >
      <router-link :to="`${ link }`"><h5 class="card-title m-0 ">{{ name }}</h5></router-link>
      <div class="d-flex justify-content-between mt-2">
        <small><span class="text-muted">{{ date | moment("from") }}</span></small>
        <manifest-cart-add-remove-item :entity="object"></manifest-cart-add-remove-item>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import ManifestCartAddRemoveItem from '../Manifest/ManifestCartAddRemoveItem.vue';
import EntityMediaWrapper from '../Entities/EntityMediaWrapper.vue';
import JobMediaWrapper from './JobMediaWrapper.vue';

export default {
  components: {
    EntityMediaWrapper,
    ManifestCartAddRemoveItem,
    JobMediaWrapper,
  },
  props: {
    object: {
      required: true,
    },
    name: {
      required: true,
    },
    link: {
      required: true,
    },
    date: {
      required: true,
    },
  },
  data() {
    return {
      jobObject: {},
    }
  },
  mounted() {
    console.log('--object----', this.object);
    // if (this.object && this.object.jobsList) {
    //   this.jobObject = this.object.jobsList[0];
    // } else {
    //   this.jobObject = this.object;
    // }

  }
};

</script>

<style scoped lang="scss">
.gridlay {
  float: left;
  width:  270px;
  height: 240px;
  object-fit: cover;
  margin: 2px;
}
.h-fixed{
  height: 150px;
  vertical-align: middle;
}
.footer-auto-bottom {
  padding: 0.5rem !important;
}
.pr-0 {
  padding-right: 0px !important;
}
</style>
